exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-mobile-chart[data-v-617988ec]{height:100%;padding:.5rem}", ""]);

// exports
